import { useState, useEffect } from "react";
import axios from "axios";
import { AlertTriangle, Info, AlertCircle } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

const LEVEL_STYLES = {
  info: {
    container: "bg-blue-50 border-blue-200 text-blue-900",
    badge: "bg-blue-600 text-white",
    icon: Info,
    label: "お知らせ",
    iconColor: "text-blue-600",
  },
  warning: {
    container: "bg-amber-50 border-amber-200 text-amber-900",
    badge: "bg-amber-500 text-white",
    icon: AlertTriangle,
    label: "注意",
    iconColor: "text-amber-600",
  },
  important: {
    container: "bg-red-50 border-red-300 text-red-900",
    badge: "bg-red-600 text-white",
    icon: AlertCircle,
    label: "重要",
    iconColor: "text-red-600",
  },
};

export default function MessageBanner() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    fetchMessages();
    // 5分ごとに自動更新
    const t = setInterval(fetchMessages, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  const fetchMessages = async () => {
    try {
      const r = await axios.get(`${API}/messages`, getAuthHeaders());
      setMessages(Array.isArray(r.data) ? r.data : []);
    } catch (e) {
      // 無視（未ログインなど）
    }
  };

  if (!messages.length) return null;

  return (
    <div className="space-y-2 mb-4" data-testid="message-banner">
      {messages.map((m) => {
        const style = LEVEL_STYLES[m.level] || LEVEL_STYLES.info;
        const Icon = style.icon;
        return (
          <div
            key={m.id}
            data-testid={`message-${m.id}`}
            className={`relative flex items-start gap-3 px-4 py-3 border rounded-sm ${style.container}`}
          >
            <Icon className={`h-5 w-5 mt-0.5 shrink-0 ${style.iconColor}`} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className={`text-[10px] px-1.5 py-0.5 rounded-sm font-semibold ${style.badge}`}>
                  {style.label}
                </span>
                <span className="font-semibold text-sm">{m.title}</span>
                <span className="text-[10px] opacity-70">
                  {new Date(m.created_at).toLocaleString("ja-JP")}
                </span>
              </div>
              {m.body && (
                <div className="mt-1 text-sm whitespace-pre-wrap break-words">
                  {m.body}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
